<template>
  <article>
      <section>
          <h1>Clipboard</h1>
      </section>
      <section>
      <div v-for="item in clipboard" :key="item.id">
          {{ item }}
      </div>
      </section>
  </article>
</template>

<script>
export default {
    data() {
        return {
            clipboard: []
        }
    },
    mounted () {
        // get clipboard from localstorage
    },
}
</script>

<style>

</style>